var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchBlobResource, fetchConsultar, fetchConsultarPaginada } from '../../../api';
var ROTA_BASE = 'reeducandos-pontos';
var buildQuery = function (filtros) {
    var params = new URLSearchParams({
        source: 'web',
        data_inicio: filtros.data_inicio,
        data_fim: filtros.data_fim,
    });
    if (filtros.colaborador_id)
        params.append('colaborador_id', String(filtros.colaborador_id));
    if (filtros.colaborador)
        params.append('colaborador', filtros.colaborador);
    if (filtros.matricula)
        params.append('matricula', filtros.matricula);
    if (filtros.instituicao_id)
        params.append('instituicao_id', String(filtros.instituicao_id));
    if (filtros.status_biometrico)
        params.append('status_biometrico', String(filtros.status_biometrico));
    return params.toString();
};
export var getAuditoriaFrequencia = function (pagination, filtros) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultarPaginada("".concat(ROTA_BASE, "/auditoria-frequencia?").concat(buildQuery(filtros)), pagination)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var buscarColaboradoresAuditoria = function (query, instituicaoId) { return __awaiter(void 0, void 0, void 0, function () {
    var termo, params, resp;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                termo = query.trim();
                if (termo.length < 3)
                    return [2 /*return*/, []];
                params = new URLSearchParams({ source: 'web', q: termo });
                if (instituicaoId)
                    params.append('instituicao_id', String(instituicaoId));
                return [4 /*yield*/, fetchConsultar("".concat(ROTA_BASE, "/auditoria-frequencia/colaboradores?").concat(params.toString()))];
            case 1:
                resp = _a.sent();
                return [2 /*return*/, Array.isArray(resp) ? resp : []];
        }
    });
}); };
export var getEmpresasAuditoria = function () { return __awaiter(void 0, void 0, Promise, function () {
    var resp;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_BASE, "/auditoria-frequencia/empresas?source=web"))];
            case 1:
                resp = _a.sent();
                return [2 /*return*/, Array.isArray(resp) ? resp : []];
        }
    });
}); };
export var exportarAuditoriaFrequenciaPdf = function (filtros) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchBlobResource("".concat(ROTA_BASE, "/auditoria-frequencia/exportar?").concat(buildQuery(filtros)))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
